export default __webpack_public_path__ + "036f049b4bef98347dfd4f3219991d52.png";